/**
 * Normalize product attribute title for storage (non-separator fields only).
 * @param {string} title
 * @returns {string}
 */
export function normalizeProductAttributeTitle(title) {
  return title.trim().replace(/\s+/g, '_');
}

/**
 * Format product attribute title for display.
 * @param {string} title
 * @param {{ isSeparator?: boolean }} [options]
 * @returns {string}
 */
export function formatProductAttributeTitle(title, { isSeparator = false } = {}) {
  if (isSeparator) {
    return title;
  }

  return title.replace(/_/g, ' ');
}
